import komjeyLogo from '../res/images/photo/komjeylogo.png';

class Images {
  static komjeyLogo = komjeyLogo;
  static query(lable) {
    return { svg: this[lable] };
  }
}
export default Images;
